export default __webpack_public_path__ + "static/media/milkyway.38694bf0.jpg";